/** @format */

import React, { Component } from 'react';
import SaleBoxes from '../../SaleBoxes/SaleBoxes';
import { Form, Icon, Header, Segment } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';

@inject('SalesStore', 'ClientsStore', 'RequestsStore')
@observer
class SaleShippingForm extends Component {
  render() {
    const { SalesStore, ClientsStore } = this.props;
    return (
      <Segment
        className={
          ClientsStore.clientsParams.dropdowns.clientAddresses.length === 0 ||
          SalesStore.currentSale.data.shippingType !== 'spedizione'
            ? 'disabled'
            : null
        }
      >
        <div className="segment-header smaller">
          <Header as="h4">
            <small>
              <Icon name="shipping fast" />
            </small>
            Spedizione
          </Header>
        </div>
        <div className="header-spacer"></div>
        <Form size="tiny" key="selectAddressForm">
          <Form.Select
            label="Seleziona indirizzo di spedizione"
            selection
            placeholder="seleziona indirizzo di spedizione"
            value={SalesStore.currentSale.data.shipping.addressId}
            options={ClientsStore.clientsParams.dropdowns.clientAddresses}
            onChange={(e, input) => SalesStore.handleSelectSaleAddress(input)}
            fluid
            size="small"
          ></Form.Select>
        </Form>
        <Segment padded key="addBoxForm">
          <div className="segment-header smaller">
            <Header as="h4">
              <small>
                <Icon name="box" />
              </small>
              Aggiungi Collo alla spedizione
            </Header>
          </div>
          <div className="header-spacer"></div>
          <Form size="tiny" onSubmit={() => SalesStore.handleNewBoxSubmit()}>
            <Form.Group widths="equal">
              <Form.Select
                name="method"
                value={SalesStore.currentBox._method}
                onChange={(e, input) => {
                  SalesStore.handleNewBoxInput(
                    input.name,
                    input.value,
                    input.options,
                  );
                }}
                onBlur={() => SalesStore.resetBoxFormErrors()}
                error={SalesStore.salesErrors.boxes.includes('method')}
                fluid
                size="small"
                options={[
                  { text: 'Bartolini Espresso 2-3gg lavorativi', value: 0 },
                  { text: 'Bartolini 5-7gg lavorativi', value: 1 },
                ]}
                label="Metodo di spedizione"
                placeholder="Metodo di spedizione"
              ></Form.Select>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                name="width"
                value={SalesStore.currentBox.width}
                onChange={(e, input) =>
                  SalesStore.handleNewBoxInput(input.name, input.value)
                }
                fluid
                type="number"
                label="Larghezza(cm)"
                placeholder="Larghezza(cm)"
              ></Form.Input>
              <Form.Input
                name="height"
                value={SalesStore.currentBox.height}
                onChange={(e, input) =>
                  SalesStore.handleNewBoxInput(input.name, input.value)
                }
                fluid
                type="number"
                label="Altezza(cm)"
                placeholder="Altezza(cm)"
              ></Form.Input>
              <Form.Input
                name="depth"
                value={SalesStore.currentBox.depth}
                onChange={(e, input) =>
                  SalesStore.handleNewBoxInput(input.name, input.value)
                }
                fluid
                type="number"
                label="Profondità(cm)"
                placeholder="Profondità(cm)"
              ></Form.Input>
              <Form.Input
                name="weight"
                value={SalesStore.currentBox.weight}
                onChange={(e, input) =>
                  SalesStore.handleNewBoxInput(input.name, input.value)
                }
                fluid
                type="number"
                label="Peso(kg)"
                placeholder="Peso(kg)"
              ></Form.Input>
              <Form.Input
                name="price"
                onBlur={() => SalesStore.resetBoxFormErrors()}
                error={SalesStore.salesErrors.boxes.includes('price')}
                value={SalesStore.currentBox.price}
                onChange={(e, input) =>
                  SalesStore.handleNewBoxInput(input.name, input.value)
                }
                fluid
                type="number"
                label="Prezzo(€)"
                placeholder="Prezzo(€)"
              ></Form.Input>
            </Form.Group>
            <Form.Button size="small" type="submit" color="green" fluid>
              <Icon name="plus" />
              Aggiungi collo
            </Form.Button>
          </Form>
        </Segment>
        <SaleBoxes />
      </Segment>
    );
  }
}

export default SaleShippingForm;
